 import React from "react";

const Footer = () => {
  var d = new Date();
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright ©2018-{d.getFullYear()} Designed &amp; Developed by DJS DAIRY
        </p>
      </div>
    </div>
  );
};

export default Footer;
